import { isDefined } from "@clipboard-health/util-ts";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { type WorkerMissingLicenseBookabilityUnmetCriteriaMetadata } from "@src/appV2/OpenShifts/ShiftAction/types";
import { useGetQualifications } from "@src/appV2/Qualifications/api/useGetQualifications";
import {
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_FULL_PATH,
  ACCOUNT_ROLES_FULL_PATH,
} from "@src/appV2/redesign/Accounts/Roles/paths";
import { useIsSurfaceShiftsEnabled } from "@src/appV2/redesign/ShiftDiscovery/useIsSurfaceShiftsEnabled";
import { generatePath } from "react-router-dom";

import { NoLicenseCard } from "./NoLicenseCard";
import { PendingLicenseCard } from "./PendingLicenseCard";

interface MissingLicenseCardContainerProps {
  metadata: WorkerMissingLicenseBookabilityUnmetCriteriaMetadata;
  shiftQualification: string;
  workplaceState?: string;
}

export function MissingLicenseCardContainer(props: MissingLicenseCardContainerProps) {
  const { shiftQualification, metadata, workplaceState } = props;
  const { status, licenseIds } = metadata;

  const isSurfaceShiftsEnabled = useIsSurfaceShiftsEnabled();

  const { data: qualifications } = useGetQualifications({
    enabled: true,
  });

  const qualification = qualifications?.data.find((q) => q.attributes.name === shiftQualification);

  if (status === "pending") {
    let href = isDefined(licenseIds[0])
      ? generatePath(DeprecatedGlobalAppV1Paths.LICENSE_DETAILS, {
          licenseId: licenseIds[0],
        })
      : DeprecatedGlobalAppV1Paths.LICENSE_MANAGER_ADD;

    if (isSurfaceShiftsEnabled) {
      href = isDefined(qualification)
        ? generatePath(ACCOUNT_ROLE_DETAILS_FULL_PATH, {
            qualificationId: qualification.id,
          })
        : ACCOUNT_ROLES_FULL_PATH;
    }

    return <PendingLicenseCard href={href} />;
  }

  let href = DeprecatedGlobalAppV1Paths.LICENSE_MANAGER_ADD;

  if (isSurfaceShiftsEnabled) {
    const queryString = workplaceState
      ? `?${new URLSearchParams({ state: workplaceState }).toString()}`
      : "";

    href = isDefined(qualification)
      ? `${generatePath(ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH, {
          qualificationId: qualification.id,
        })}${queryString}`
      : ACCOUNT_ROLES_FULL_PATH;
  }

  return <NoLicenseCard href={href} workplaceState={workplaceState} />;
}
